import { render, staticRenderFns } from "./gytlxc.vue?vue&type=template&id=20aec198&scoped=true"
import script from "./gytlxc.vue?vue&type=script&lang=js"
export * from "./gytlxc.vue?vue&type=script&lang=js"
import style0 from "./gytlxc.vue?vue&type=style&index=0&id=20aec198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aec198",
  null
  
)

export default component.exports